import PubSub from "underpub-js";
import gsap from "gsap";
import { SteppedEase } from "gsap/all";
import SplitText from "gsap/SplitText"; // Ensure you import SplitText correctly

var Loader = function (options) {
  this.options = {
    $el: false,
    baseClass: "mol-Loader",
    hasLoaded: false,
  };

  $.extend(true, this.options, options);
};

Loader.prototype.init = function () {
  const self = this;

  self.$icon = self.options.$el.find(`.${self.options.baseClass}__icon`);

  self.initLoaderAnimation();
  self.initLoaderInAnimation();
  self.initLoaderOutAnimation();
  // self.initHeroAfterLoading();

  // Check if the loader has already been shown in this session
  if (!sessionStorage.getItem("loaderShown")) {
    $(window).on("load", () => self.handleWindowLoad());
    sessionStorage.setItem("loaderShown", "true");
  } else {
    self.killLoader();
  }

  setTimeout(() => !self.options.hasLoaded && $(window).trigger("load"), 2000);
};

Loader.prototype.initLoaderInAnimation = function () {
  const self = this;

  // the timeline that will play first and animate in the loader icon
  gsap
    .timeline()
    .set("body", {
      opacity: 1,
    })
    .fromTo(
      self.$icon,
      {
        scale: 0,
        opacity: 0,
      },
      {
        scale: 1,
        opacity: 1,
        ease: "back.out(1.5)",
        duration: 0.3,
        delay: 0.1,
      }
    )
    .call(self.playLoaderAnimation.bind(self));
};

Loader.prototype.killLoader = function () {
  const self = this;

  self.options.$el.hide();
  $("html").removeClass("loading");
  gsap.set("body", {
    clearProps: "opacity",
  });
  self.killLoaderAnimation();
};

Loader.prototype.initLoaderAnimation = function () {
  const self = this;

  // the timeline that should be used for animations that take place while the loader is on screen
  self.loaderTimeline = gsap
    .timeline({
      repeatDelay: 0,
      repeat: -1,
      repeatRefresh: true,
      delay: 0.1,
      paused: true,
      defaults: {
        ease: "expo.out",
      },
    })
    .to(self.$icon, {
      // rotation: "+=90",
      duration: 0.8,
    });
};

Loader.prototype.initLoaderOutAnimation = function () {
  const self = this;

  // the timeline that plays when loading is complete
  self.loaderOutTimeline = gsap
    .timeline({
      delay: 1.3,
      paused: true,
      defaults: {
        ease: "expo.out",
      },
      onStart: () => PubSub.publish("Sitewide:loaded"),
      onComplete: () => self.killLoader(),
    })
    .set(self.options.$el, {
      pointerEvents: "none",
    })
    .to(self.$icon, {
      ease: "back.out(1.5)",
      duration: 0.4,
      opacity: 0,
      scale: 0,
    })
    .to(
      self.options.$el,
      {
        duration: 1.5,
        opacity: 0,
      },
      "-=.2"
    )
    .call(
      () => {
        PubSub.publish("Sitewide:loaderOutComplete");
      },
      [],
      ">-=1"
    );
};

Loader.prototype.playLoaderAnimation = function () {
  const self = this;

  self.loaderTimeline.play();
};

Loader.prototype.killLoaderAnimation = function () {
  const self = this;

  self.loaderTimeline.kill();
};

Loader.prototype.playLoaderOutAnimation = function () {
  const self = this;

  self.loaderOutTimeline.play();
};

Loader.prototype.handleWindowLoad = function () {
  const self = this;

  self.options.hasLoaded = true;
  self.playLoaderOutAnimation();

  self.initSceneAnimation(); // Initialize the additional animation

  // Calculate dynamic properties
  self.calculateProperties();
  window.addEventListener(
    "resize",
    self.debounce(() => self.calculateProperties())
  );
};

Loader.prototype.initSceneAnimation = function () {
  const scene = {
    frames: 22,
    frameRate: 40,
    frameHeight: 205,
    spriteHeight: 4510,
  };

  // Transform
  const duration = scene.frames / scene.frameRate;
  const tl = gsap.timeline();
  tl.fromTo(
    ".animation-image",
    { y: "0%" },
    {
      y:
        ((scene.spriteHeight - scene.frameHeight) / scene.spriteHeight) * -100 +
        "%",
      ease: SteppedEase.config(scene.frames - 1),
      duration: duration,
      stagger: {
        each: duration,
      },
    }
  );
};

// Calculate padding-bottom and image width dynamically
Loader.prototype.calculateProperties = function () {
  const bg = document.querySelector(".scrub-loader");
  const bgHeight = bg.clientHeight;
  const PB = bgHeight / 3;
  const actualPB = PB + 0.44 * PB;
  const imageWidth = actualPB * 22 * 0.221;

  bg.style.setProperty("--padding-bottom", `${actualPB}px`);
  bg.style.setProperty("--image-width", `${imageWidth}px`);
};

// Debounce function to limit the rate at which a function can fire
Loader.prototype.debounce = function (func) {
  let timer;
  return function (event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 100, event);
  };
};

// Modified initHero function
// Loader.prototype.initHeroAfterLoading = function () {
//   const quote = document.querySelector(".leadspace-heading");
//   const fadeLabel = document.querySelector(".fade-label");
//   const fadeCopy = document.querySelector(".fade-copy");
//   const fadeButton = document.querySelector(".fade-button");

//   // Split the text in the quote element
//   const childSplit = new SplitText(quote, {
//     type: "lines,words,chars",
//     linesClass: "split-child",
//   });
//   const parentSplit = new SplitText(quote, {
//     linesClass: "split-parent",
//   });

//   // Timeline for the animations
//   const tl = gsap.timeline();

//   // Animate fadeLabel
//   tl.to(fadeLabel, {
//     opacity: 1,
//     duration: 0.5,
//     delay: !sessionStorage.getItem("loaderShown") ? 2 : 1,
//     ease: "sine.out",
//     translateY: 0,
//   });

//   // Animate quote after fadeLabel
//   tl.from(
//     childSplit.lines,
//     {
//       duration: 1,
//       ease: "sine.out",
//       yPercent: 160,
//       stagger: 0.1,
//     },
//     "+=0.05"
//   );

//   // Animate fadeCopy after quote
//   if (fadeCopy) {
//     tl.to(
//       fadeCopy,
//       {
//         opacity: 1,
//         duration: 0.5,
//         ease: "sine.out",
//         translateY: 0,
//       },
//       "+=0.05"
//     );
//   }

//   // Animate fadeButton after fadeCopy
//   tl.to(
//     fadeButton,
//     {
//       opacity: 1,
//       duration: 0.5,
//       ease: "sine.out",
//       translateY: 0,
//     },
//     "+=0.05"
//   );
// };


export default Loader;
